// В.2.a: Лив Лайф — диспетчер Действий. На каркасе ни одно Действие не было
// реализовано (стаб-логика).
// В.2.c: подключены 3 common-Действия (Синт-кожа, В карантин!, Инъекция
// адреналина). rare/epic/legendary Действия — реализуем в В.2.d-f.

import * as sintKozha from './sint_kozha.js';
import * as vKarantin from './v_karantin.js';
import * as inektsiya from './inektsiya_adrenalina.js';
import * as perelivanie from './perelivanie_krovi.js';
import * as otsifrovka from './otsifrovka_dushi.js';
import * as virusHv14 from './virus_hv_14.js';
// В.2.f-2: legendary-Действия (без picker'а).
import * as oblako from './toksichnoe_oblako.js';
import * as dovod from './posledniy_dovod.js';
import * as feniks from './proekt_obgorevshiy_feniks.js';

const TARGETED = new Set([
  sintKozha.CARD_ID,
  vKarantin.CARD_ID,
  inektsiya.CARD_ID,
  perelivanie.CARD_ID,
  otsifrovka.CARD_ID,
  virusHv14.CARD_ID
]);

const HANDLERS = {
  [sintKozha.CARD_ID]: { targets: sintKozha.actionTargets, resolve: sintKozha.resolve },
  [vKarantin.CARD_ID]: { targets: vKarantin.actionTargets, resolve: vKarantin.resolve },
  [inektsiya.CARD_ID]: { targets: inektsiya.actionTargets, resolve: inektsiya.resolve },
  [perelivanie.CARD_ID]: { targets: perelivanie.actionTargets, resolve: perelivanie.resolve },
  [otsifrovka.CARD_ID]:  { targets: otsifrovka.actionTargets,  resolve: otsifrovka.resolve  },
  [virusHv14.CARD_ID]:   { targets: virusHv14.actionTargets,   resolve: virusHv14.resolve   },
  [oblako.CARD_ID]:      { targets: oblako.actionTargets,      resolve: oblako.resolve      },
  [dovod.CARD_ID]:       { targets: dovod.actionTargets,       resolve: dovod.resolve       },
  [feniks.CARD_ID]:      { targets: feniks.actionTargets,      resolve: feniks.resolve      }
};

// C.1: импорт новых v6 Действий Лив Лайфа.
import { TARGETED_C1, getActionTargetsC1, resolveActionC1 } from './c1/actions-c1.js';

export function actionNeedsTarget(cardId) {
  if (TARGETED_C1.has(cardId)) return true;
  return TARGETED.has(cardId);
}

export function getActionTargets(state, playerIdx, cardId) {
  // C.1 v6 — сначала пробуем новые.
  if (cardId.startsWith('livlife_act_')) {
    return getActionTargetsC1(state, playerIdx, cardId);
  }
  const h = HANDLERS[cardId];
  return h ? h.targets(state, playerIdx) : [];
}

export function resolveAction(state, playerIdx, cardId, target = null, opts = {}) {
  // C.1 v6 Действия — пробуем сначала новые.
  if (cardId.startsWith('livlife_act_')) {
    const result = resolveActionC1(state, playerIdx, cardId, target, opts);
    if (result !== null) return result;
  }
  // Легаси-резолвер (старые ID Лив Лайфа).
  const h = HANDLERS[cardId];
  if (h) return h.resolve(state, playerIdx, target, opts);
  // Стаб для незарегистрированных.
  const p = state.players[playerIdx];
  let name = cardId;
  for (const arr of [p.hand, p.discard]) {
    const c = arr.find(x => x.id === cardId);
    if (c) { name = c.name_ru || cardId; break; }
  }
  state.log.add(`🎴 ${name}: эффект не реализован, пропущен`);
  return { ok: true, stub: true };
}
